import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import YildizArkaplan from "../components/YildizArkaplan";
import { FALCILAR } from "../data/falcilar";
import { useToken } from "../context/TokenContext";
import { useFal } from "../context/FalContext";
import { supabase } from "../supabaseClient";
import { useTranslation } from "react-i18next";

const FAL_ISIM_KEY = {
  kahve: "readings.coffee",
  el: "readings.hand",
  yuz: "readings.face",
  iliski: "readings.relationship",
};

const FAL_TURLERI = [
  { id: "kahve", isimKey: "readings.coffee", emoji: "☕" },
  { id: "el", isimKey: "readings.hand", emoji: "✋" },
  { id: "yuz", isimKey: "readings.face", emoji: "👤" },
  { id: "iliski", isimKey: "readings.relationship", emoji: "💑" },
];

function YildizPuan({ puan, buyuk }) {
  return (
    <div style={{ display: "flex", gap: buyuk ? 4 : 2 }}>
      {[1, 2, 3, 4, 5].map((y) => (
        <span key={y} style={{
          fontSize: buyuk ? 20 : 12,
          color: y <= Math.round(puan) ? "#F9CB42" : "rgba(255,255,255,0.2)"
        }}>★</span>
      ))}
    </div>
  );
}

export default function FalciProfil() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useToken();
  const { fallar } = useFal();
  const { t } = useTranslation();
  const falci = FALCILAR.find((f) => f.id === id);

  const [secilenFal, setSecilenFal] = useState(null);
  const [aktifTab, setAktifTab] = useState("profil");
  const [yorumlar, setYorumlar] = useState([]);
  const [yorumYukluyor, setYorumYukluyor] = useState(false);
  const [yorumFormu, setYorumFormu] = useState({ puan: 5, yorum: "" });
  const [yorumGonderiliyor, setYorumGonderiliyor] = useState(false);
  const [yorumGonderildi, setYorumGonderildi] = useState(false);

  const falBaktirdi = fallar.some(f => f.falci_id === id && f.durum !== "bekliyor");

  useEffect(() => {
    if (aktifTab === "yorumlar") fetchYorumlar();
  }, [aktifTab]);

  async function fetchYorumlar() {
    setYorumYukluyor(true);
    const { data } = await supabase
      .from("falci_yorumlar").select("*").eq("falci_id", id)
      .order("created_at", { ascending: false });
    setYorumlar(data || []);
    setYorumYukluyor(false);
  }

  async function yorumGonder() {
    if (!yorumFormu.yorum.trim() || yorumGonderiliyor) return;
    setYorumGonderiliyor(true);
    const kullaniciAdi = user?.user_metadata?.display_name || user?.email?.split("@")[0] || "Kullanıcı";
    await supabase.from("falci_yorumlar").insert({
      falci_id: id, user_id: user.id, kullanici_adi: kullaniciAdi,
      puan: yorumFormu.puan, yorum: yorumFormu.yorum,
      fal_turu: fallar.find(f => f.falci_id === id)?.fal_turu || "kahve",
    });
    setYorumGonderildi(true);
    setYorumFormu({ puan: 5, yorum: "" });
    setYorumGonderiliyor(false);
    fetchYorumlar();
  }

  const katilimTarihi = (tarih) => new Date(tarih).toLocaleDateString(undefined, { year: "numeric", month: "long" });

  if (!falci) return <div style={{ color: "#fff", padding: 40, textAlign: "center" }}>Falcı bulunamadı.</div>;

  const tumYorumlar = [
    ...yorumlar.map(y => ({
      kullanici: y.kullanici_adi, puan: y.puan, yorum: y.yorum,
      fal: t(FAL_ISIM_KEY[y.fal_turu] || "readings.coffee"),
      sure: new Date(y.created_at).toLocaleDateString(undefined, { day: "numeric", month: "long" }),
      gercek: true,
    })),
    ...falci.defaultYorumlar,
  ];

  const ortalamaPuan = tumYorumlar.reduce((acc, y) => acc + y.puan, 0) / tumYorumlar.length;

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative", fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420, margin: "0 auto",
    }}>
      <style>{`
        @keyframes kart-gir { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
        textarea:focus { outline: none; }
      `}</style>

      <YildizArkaplan />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 100 }}>

        {/* Geri */}
        <div style={{ padding: "52px 24px 0" }}>
          <button onClick={() => navigate(-1)} style={{
            background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: 12, padding: "8px 16px", color: "rgba(255,255,255,0.7)", fontSize: 13, cursor: "pointer",
          }}>{t("readerProfile.back")}</button>
        </div>

        {/* Hero Kart */}
        <div style={{
          margin: "20px 24px 0", borderRadius: 20,
          background: `linear-gradient(135deg, ${falci.renk}55 0%, rgba(255,255,255,0.03) 100%)`,
          border: `1px solid ${falci.parlak}44`, padding: "24px",
          animation: "kart-gir 0.5s ease backwards",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div style={{
              width: 80, height: 80, borderRadius: 22,
              background: `${falci.renk}44`, border: `2px solid ${falci.parlak}66`,
              display: "flex", alignItems: "center", justifyContent: "center", fontSize: 38, flexShrink: 0,
            }}>{falci.emoji}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 20, fontWeight: 800, color: "#fff", fontFamily: "Georgia, serif" }}>{falci.isim}</div>
              <div style={{ fontSize: 13, color: falci.parlak, fontWeight: 600, marginTop: 2 }}>{falci.unvan}</div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}>
                <YildizPuan puan={ortalamaPuan} />
                <span style={{ fontSize: 12, color: "#F9CB42", fontWeight: 700 }}>{ortalamaPuan.toFixed(1)}</span>
                <span style={{ fontSize: 11, color: "rgba(255,255,255,0.3)" }}>({tumYorumlar.length} {t("readerProfile.ratingLabel")})</span>
              </div>
            </div>
            <div style={{
              padding: "4px 12px", borderRadius: 20, fontSize: 11, fontWeight: 700,
              background: falci.online ? "rgba(52,211,153,0.15)" : "rgba(255,255,255,0.06)",
              color: falci.online ? "#34D399" : "rgba(255,255,255,0.3)",
              border: falci.online ? "1px solid rgba(52,211,153,0.3)" : "1px solid rgba(255,255,255,0.1)",
            }}>
              {falci.online ? t("readers.online") : t("readers.offline")}
            </div>
          </div>

          {/* İstatistikler */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginTop: 20 }}>
            {[
              { label: t("readerProfile.stats.readings"), deger: falci.falSayisi.toLocaleString(), icon: "🔮" },
              { label: t("readerProfile.stats.comments"), deger: tumYorumlar.length, icon: "💬" },
              { label: t("readerProfile.stats.joined"), deger: katilimTarihi(falci.katilimTarihi), icon: "📅" },
            ].map((stat, i) => (
              <div key={i} style={{
                background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: 12, padding: "10px 8px", textAlign: "center",
              }}>
                <div style={{ fontSize: 16, marginBottom: 4 }}>{stat.icon}</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>{stat.deger}</div>
                <div style={{ fontSize: 10, color: "rgba(255,255,255,0.4)", marginTop: 2 }}>{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Token */}
          <div style={{
            marginTop: 14, display: "flex", alignItems: "center", justifyContent: "space-between",
            borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: 14,
          }}>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)" }}>{t("readerProfile.perReading")}</div>
            <div style={{
              background: "rgba(249,203,66,0.15)", border: "1px solid rgba(249,203,66,0.3)",
              borderRadius: 20, padding: "4px 14px", fontSize: 14, color: "#F9CB42", fontWeight: 700,
            }}>
              {t("readerProfile.token", { token: falci.token })}
            </div>
          </div>
        </div>

        {/* Tab Menü */}
        <div style={{ display: "flex", margin: "20px 24px 0", gap: 8 }}>
          {[
            { id: "profil", label: t("readerProfile.tabProfile") },
            { id: "yorumlar", label: t("readerProfile.tabComments", { count: tumYorumlar.length }) },
            { id: "fal-sec", label: t("readerProfile.tabRead") },
          ].map(tab => (
            <button key={tab.id} onClick={() => setAktifTab(tab.id)} style={{
              flex: 1, padding: "10px 8px", borderRadius: 12, border: "none", cursor: "pointer",
              background: aktifTab === tab.id ? `${falci.renk}66` : "rgba(255,255,255,0.05)",
              color: aktifTab === tab.id ? "#fff" : "rgba(255,255,255,0.4)",
              fontSize: 12, fontWeight: aktifTab === tab.id ? 700 : 500,
              border: aktifTab === tab.id ? `1px solid ${falci.parlak}44` : "1px solid rgba(255,255,255,0.08)",
              transition: "all 0.2s",
            }}>{tab.label}</button>
          ))}
        </div>

        {/* PROFİL TAB */}
        {aktifTab === "profil" && (
          <div style={{ padding: "20px 24px 0", animation: "kart-gir 0.4s ease backwards" }}>
            <div style={{
              background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 16, padding: "18px",
            }}>
              <div style={{ fontSize: 12, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 10 }}>
                {t("readerProfile.about")}
              </div>
              <div style={{ fontSize: 14, color: "rgba(255,255,255,0.7)", lineHeight: 1.7 }}>{falci.hakkinda}</div>
            </div>

            <div style={{ marginTop: 16 }}>
              <div style={{ fontSize: 12, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 10 }}>
                {t("readerProfile.expertise")}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {falci.uzmanlik.map((alan, i) => (
                  <div key={i} style={{
                    background: `${falci.renk}33`, border: `1px solid ${falci.parlak}44`,
                    borderRadius: 20, padding: "6px 14px", fontSize: 12, color: falci.parlak, fontWeight: 600,
                  }}>{alan}</div>
                ))}
              </div>
            </div>

            <div style={{ marginTop: 20 }}>
              <div style={{ fontSize: 12, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 10 }}>
                {t("readerProfile.recentComments")}
              </div>
              {tumYorumlar.slice(0, 3).map((y, i) => (
                <div key={i} style={{
                  background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
                  borderRadius: 14, padding: "14px", marginBottom: 10,
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div style={{
                        width: 30, height: 30, borderRadius: "50%",
                        background: `${falci.renk}44`, border: `1px solid ${falci.parlak}44`,
                        display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14,
                      }}>{y.kullanici[0]}</div>
                      <div>
                        <div style={{ fontSize: 13, color: "#fff", fontWeight: 600 }}>{y.kullanici}</div>
                        <div style={{ fontSize: 10, color: "rgba(255,255,255,0.3)" }}>{y.fal}</div>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 2 }}>
                      <YildizPuan puan={y.puan} />
                      <div style={{ fontSize: 10, color: "rgba(255,255,255,0.3)" }}>{y.sure}</div>
                    </div>
                  </div>
                  <div style={{ fontSize: 13, color: "rgba(255,255,255,0.65)", lineHeight: 1.5 }}>"{y.yorum}"</div>
                </div>
              ))}
              <button onClick={() => setAktifTab("yorumlar")} style={{
                width: "100%", padding: "10px", borderRadius: 12,
                background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
                color: "rgba(255,255,255,0.4)", fontSize: 12, cursor: "pointer",
              }}>
                {t("readerProfile.allComments", { count: tumYorumlar.length })}
              </button>
            </div>

            <button onClick={() => setAktifTab("fal-sec")} style={{
              width: "100%", padding: "16px", borderRadius: 16, marginTop: 20,
              background: `linear-gradient(135deg, ${falci.renk} 0%, ${falci.parlak}99 100%)`,
              border: "none", color: "#fff", fontSize: 16, fontWeight: 700,
              cursor: "pointer", fontFamily: "Georgia, serif",
            }}>
              {falci.emoji} {t("readerProfile.readBtn", { token: falci.token })}
            </button>
          </div>
        )}

        {/* YORUMLAR TAB */}
        {aktifTab === "yorumlar" && (
          <div style={{ padding: "20px 24px 0", animation: "kart-gir 0.4s ease backwards" }}>
            <div style={{
              background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 16, padding: "18px", marginBottom: 16,
              display: "flex", alignItems: "center", gap: 20,
            }}>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: 40, fontWeight: 800, color: "#F9CB42" }}>{ortalamaPuan.toFixed(1)}</div>
                <YildizPuan puan={ortalamaPuan} buyuk />
                <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginTop: 4 }}>{tumYorumlar.length} {t("readerProfile.ratingLabel")}</div>
              </div>
              <div style={{ flex: 1 }}>
                {[5, 4, 3, 2, 1].map(y => {
                  const sayi = tumYorumlar.filter(v => v.puan === y).length;
                  const yuzde = tumYorumlar.length ? (sayi / tumYorumlar.length) * 100 : 0;
                  return (
                    <div key={y} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                      <div style={{ fontSize: 11, color: "#F9CB42", width: 8 }}>{y}</div>
                      <div style={{ flex: 1, height: 6, borderRadius: 3, background: "rgba(255,255,255,0.1)", overflow: "hidden" }}>
                        <div style={{ width: `${yuzde}%`, height: "100%", background: "#F9CB42", borderRadius: 3 }} />
                      </div>
                      <div style={{ fontSize: 10, color: "rgba(255,255,255,0.3)", width: 16 }}>{sayi}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            {falBaktirdi && !yorumGonderildi && (
              <div style={{
                background: `${falci.renk}22`, border: `1px solid ${falci.parlak}33`,
                borderRadius: 16, padding: "18px", marginBottom: 16,
              }}>
                <div style={{ fontSize: 13, color: falci.parlak, fontWeight: 700, marginBottom: 12 }}>
                  {t("readerProfile.addComment")}
                </div>
                <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                  {[1, 2, 3, 4, 5].map(y => (
                    <button key={y} onClick={() => setYorumFormu(p => ({ ...p, puan: y }))} style={{
                      fontSize: 24, background: "none", border: "none", cursor: "pointer",
                      opacity: y <= yorumFormu.puan ? 1 : 0.3, transition: "opacity 0.2s",
                    }}>★</button>
                  ))}
                </div>
                <textarea
                  value={yorumFormu.yorum}
                  onChange={e => setYorumFormu(p => ({ ...p, yorum: e.target.value }))}
                  placeholder={t("readerProfile.commentPlaceholder")}
                  rows={3}
                  style={{
                    width: "100%", background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.12)", borderRadius: 12,
                    padding: "12px", color: "#fff", fontSize: 13, resize: "none",
                    fontFamily: "'Trebuchet MS', sans-serif",
                  }}
                />
                <button onClick={yorumGonder} disabled={!yorumFormu.yorum.trim() || yorumGonderiliyor} style={{
                  width: "100%", padding: "12px", borderRadius: 12, marginTop: 10,
                  background: yorumFormu.yorum.trim() ? `linear-gradient(135deg, ${falci.renk}, ${falci.parlak})` : "rgba(255,255,255,0.06)",
                  border: "none", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer",
                }}>
                  {yorumGonderiliyor ? t("readerProfile.submitting") : t("readerProfile.submitComment")}
                </button>
              </div>
            )}

            {yorumGonderildi && (
              <div style={{
                background: "rgba(52,211,153,0.1)", border: "1px solid rgba(52,211,153,0.3)",
                borderRadius: 14, padding: "14px", marginBottom: 16, textAlign: "center",
                color: "#34D399", fontSize: 13, fontWeight: 600,
              }}>
                {t("readerProfile.commentSuccess")}
              </div>
            )}

            {yorumYukluyor ? (
              <div style={{ textAlign: "center", padding: "20px", color: "rgba(255,255,255,0.3)" }}>Yükleniyor...</div>
            ) : (
              tumYorumlar.map((y, i) => (
                <div key={i} style={{
                  background: "rgba(255,255,255,0.04)",
                  border: y.gercek ? `1px solid ${falci.parlak}33` : "1px solid rgba(255,255,255,0.08)",
                  borderRadius: 14, padding: "14px", marginBottom: 10,
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div style={{
                        width: 32, height: 32, borderRadius: "50%",
                        background: `${falci.renk}44`, border: `1px solid ${falci.parlak}44`,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 14, fontWeight: 700, color: falci.parlak,
                      }}>{y.kullanici[0]}</div>
                      <div>
                        <div style={{ fontSize: 13, color: "#fff", fontWeight: 600 }}>
                          {y.kullanici}
                          {y.gercek && <span style={{ fontSize: 10, color: "#34D399", marginLeft: 6 }}>{t("readerProfile.verified")}</span>}
                        </div>
                        <div style={{ fontSize: 10, color: "rgba(255,255,255,0.3)" }}>{y.fal}</div>
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <YildizPuan puan={y.puan} />
                      <div style={{ fontSize: 10, color: "rgba(255,255,255,0.3)", marginTop: 2 }}>{y.sure}</div>
                    </div>
                  </div>
                  <div style={{ fontSize: 13, color: "rgba(255,255,255,0.65)", lineHeight: 1.5 }}>"{y.yorum}"</div>
                </div>
              ))
            )}
          </div>
        )}

        {/* FAL SEÇ TAB */}
        {aktifTab === "fal-sec" && (
          <div style={{ padding: "20px 24px 0", animation: "kart-gir 0.4s ease backwards" }}>
            <div style={{ fontSize: 12, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 14 }}>
              {t("readerProfile.selectType")}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              {FAL_TURLERI.map((fal) => (
                <div key={fal.id} onClick={() => setSecilenFal(fal.id)} style={{
                  borderRadius: 16, padding: "20px 16px", cursor: "pointer", textAlign: "center",
                  background: secilenFal === fal.id ? `${falci.renk}44` : "rgba(255,255,255,0.04)",
                  border: secilenFal === fal.id ? `1px solid ${falci.parlak}88` : "1px solid rgba(255,255,255,0.08)",
                  transition: "all 0.2s",
                }}>
                  <div style={{ fontSize: 32, marginBottom: 8 }}>{fal.emoji}</div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: secilenFal === fal.id ? "#fff" : "rgba(255,255,255,0.6)" }}>
                    {t(fal.isimKey)}
                  </div>
                </div>
              ))}
            </div>

            {secilenFal && (
              <button onClick={() => navigate(`/fal/${falci.id}/${secilenFal}`)} style={{
                width: "100%", padding: "16px", borderRadius: 16, marginTop: 20,
                background: `linear-gradient(135deg, ${falci.renk} 0%, ${falci.parlak}99 100%)`,
                border: "none", color: "#fff", fontSize: 16, fontWeight: 700,
                cursor: "pointer", fontFamily: "Georgia, serif",
                animation: "kart-gir 0.3s ease backwards",
              }}>
                {falci.emoji} {t("readerProfile.readBtn", { token: falci.token })}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}